import { useLocation } from 'react-router';

import { normalizePathname } from 'src/shared/helpers/url';
import { Route } from 'src/shared/route';

import { HeaderCallToAction } from './enum';

const routes = Object.values(Route);

const useHeaderCallToAction = () => {
  const location = useLocation();

  const { pathname } = location;

  const currentRoute = routes.find(
    ({ path }) => path === normalizePathname(pathname),
  );

  return currentRoute && 'headerCallToAction' in currentRoute
    ? currentRoute.headerCallToAction
    : HeaderCallToAction.LOGIN;
};

export { useHeaderCallToAction };
